import { handleActions } from 'redux-actions'

import { JitsiConnection } from 'lib-jitsi-meet'

import * as connectionActions from '../actions/connection'

export interface ConnectionState {
  connection: JitsiConnection | null
  roomId: number
  isCallStarted: boolean
  presenterId: number | null
  accessToken: string
}

const initialState: ConnectionState = {
  connection: null,
  roomId: 0,
  isCallStarted: false,
  presenterId: 0,
  accessToken: '',
}

export default handleActions<ConnectionState, any>(
  {
    [connectionActions.startCall.toString()](state) {
      return { ...state, isCallStarted: true }
    },
    [connectionActions.endCall.toString()](state) {
      return { ...state, isCallStarted: false }
    },
    [connectionActions.setJitsiConnection.toString()](
      state,
      action: ReturnType<typeof connectionActions.setJitsiConnection>
    ) {
      return { ...state, connection: action.payload }
    },
    [connectionActions.setPresenter.toString()](state, action) {
      return { ...state, presenterId: action.payload }
    },
    [connectionActions.setRoomId.toString()](state, action: ReturnType<typeof connectionActions.setRoomId>) {
      return { ...state, roomId: action.payload }
    },
    [connectionActions.resetJitsiConnection.toString()](state) {
      return { ...state, connection: null }
    },
    [connectionActions.getJitsiToken.success.toString()](
      state,
      action: ReturnType<typeof connectionActions.getJitsiToken.success>
    ) {
      return { ...state, accessToken: action.response.data.access_token }
    },
  },
  initialState
)
